import React from 'react';
import Reflux from 'reflux';
import DocumentMeta from 'react-document-meta';
import RcIf from 'rc-if';

import AppActions from '../AppActions';
import AppStore from '../AppStore';
import history from '../history';
import * as Utilities from '../Utilities';
import TopicBoxRelated from './TopicBoxRelated';

import Comments from './Comments';
import TopBox from '../components/topic/TopBox';
import TopicHeader from './topic/TopicHeader';
import Suggested from '../components/topic/Suggested';
import OtherOptions from '../components/topic/OtherOptions';
import OptionsHeader from '../components/topic/OptionsHeader';
import OptionsFooter from '../components/topic/OptionsFooter';

import './Topic.css';

class Topic extends Reflux.Component {
    constructor (props) {
        super(props);

        this.setState({
            loadingTopicInformation: true,
            loadingOptions: true,
            loadingComments: true
        });

        let redirectToHome = false;
        let topicId;
        let topic;
        let titleNewTopic;
        let enableEditing = false;
        let invalidGlobalTopic = !this.props.topicId || this.props.topicId.indexOf('g_') === -1;
        let invalidTopic = !this.props.topicId || this.props.topicId.indexOf('_') === -1;
        let invalidTitleNewTopic = !this.props.title;
        if (invalidTopic && invalidGlobalTopic && invalidTitleNewTopic && !this.props.autogenerateTitle) {
            redirectToHome = true;
        } else if (!invalidGlobalTopic) {
            topic = this.props.topicId.split('_')[1];
        } else if (this.props.autogenerateTitle) {
            topic = this.props.autogenerateTitle;
        } else if (this.props.title) {
            topic = this.props.title;
            AppActions.getTopicActivity(this.props.title);
            AppActions.getPopularSentencesByTitle(this.props.title, 8);
            AppActions.getTopicSuggestions(this.props.title);
            enableEditing = true;
        } else {
            topicId = this.props.topicId.split('_')[0];
            topic = this.props.topicId.split('_')[1];
        }

        this.state = {
            currentTopic: {
                title: this.props.title,
                options: []
            },
            options: [
                {
                    position: 1
                }, {
                    position: 2
                }, {
                    position: 3
                }, {
                    position: 4
                }, {
                    position: 5
                }
            ],
            relatedTopics: [],
            otherOptions: [],
            url: process.env.REACT_APP_PUBLIC_URL + '/topic/' + this.props.topicId,
            sugestTranslate: {},
            topicId: topicId,
            titleNewTopic: titleNewTopic,
            topic: topic,
            autogenerateTitle: this.props.autogenerateTitle,
            disableArrows: this.props.disableArrows || false,
            disableCreation: this.props.disableCreation || false,
            enableEditing: enableEditing || false,
            title: this.props.title,
            topicActivity: {},
            redirectToHome: redirectToHome
        };
        this.store = AppStore;
    }
    componentDidMount () {
        AppActions.cleanTopic();
        AppActions.newTopicStart();

        if (!this.state.redirectToHome) {
            AppActions.cleanComments();
            if (this.state.topicId) {
                AppActions.getTopicById(this.state.topicId, this.state.topic);
            } else if (/^g_/.test(this.props.topicId)) {
                const globalTopic = this.props.topicId.replace('g_', '').replace(/-/g, ' ');
                AppActions.getGlobal(globalTopic);
            } else if (this.props.title) {
                this.setState({enableEditing: true, title: this.props.title});
            }
            if (this.state.autogenerateTitle) {
                AppActions.getAutogeneratedByTitle(this.state.autogenerateTitle);
            }
        } else {
            return history.push('/notfound');
        }
    }

    componentWillReceiveProps (newProps) {
        let disableArrows = newProps.disableArrows || this.state.disableArrows;
        let disableCreation = newProps.disableCreation || this.state.disableCreation;
        let autogenerateTitle = newProps.autogenerateTitle || this.state.autogenerateTitle;
        if (newProps.title) {
            this.setState({enableEditing: true, title: newProps.title});
            return;
        }
        if (this.props.topicId !== newProps.topicId) {
            if (/^g_/.test(newProps.topicId)) {
                let globalTopic = newProps.topicId.replace('g_', '').replace(/-/g, ' ');
                this.setState({globalTopic: globalTopic, disableArrows, disableCreation, autogenerateTitle});
                AppActions.getGlobal(globalTopic);
            } else {
                let topicId = newProps.topicId.split('_')[0];
                let topic = newProps.topicId.split('_')[1];
                this.setState({globalTopic: false, disableArrows, disableCreation, autogenerateTitle});
                AppActions.getTopicById(topicId, topic);
            }
        }
    }
    makeTop = () => {
        let isCreator = this.isCreator();
        let isSameTopicByMe = this.state.isSameTopicByMe;
        if (isSameTopicByMe && !isCreator) {
            this.goToMyTopic();
        } else {
            this.setState({enableEditing: true});
        }
    }
    viewUserTop = () => {
        this.setState({enableEditing: false});
    }
    validateTopic = () => {
        let valid = true;
        let errors = [];
        if (!this.state.title) {
            errors.push('El titulo es un campo requerido.');
            valid = false;
        }
        let options = this.state.options.filter((option) => {
            return option.sentence;
        });
        if (this.isCreator()) {
            options = this.state.creatorOptions.filter((option) => {
                return option.sentence;
            });
        }
        if (options.length === 0) {
            errors.push('Se require al menos una opcion.', this.state.options);
            valid = false;
        }
        if (errors.length > 0) {
            console.error('errors: ' + JSON.stringify(errors));
        }
        this.setState({errors: errors});
        return valid;
    }
    handleNewTopic = () => {
        if (!this.validateTopic() || this.state.uploadingTopic) {
            return;
        }
        let options = this.isCreator() ? this.state.creatorOptions : this.state.options;
        let currentTopic = this.state.currentTopic;
        currentTopic.options = options;
        this.setState({currentTopic});
        let topic = {
            options,
            title: this.state.title
        };
        AppActions.createTopic(topic);
    };

    sugestTranslate = () => {
        let translateData = {
            topic_id: this.state.currentTopic._id,
            sentence: this.state.sugestTranslate.title,
            country: this.state.sugestTranslate.country
        };
        AppActions.sugestTranslate(translateData);
    }

    favTopic = () => {
        if (this.state.isTopicFaved) {
            AppActions.removeTopicFromListByName(this.state.currentTopic.title, 'favorites');
        } else {
            AppActions.addToTopicListByName(this.state.currentTopic.title, 'favorites');
        }
    }

    _renderLoadingRightCol = () => {
        return (
          <div className='col l5 s12'>
            <div className='rightCol'>
              <img src='/images/loaders/rightCol.svg' />
            </div>
          </div>
        );
    }
    _renderLoadingComments = () => {
        return (
          <img src='/images/loaders/comment-load.svg' />
        );
    }

    _renderTopicInformation = () => {
        if (this.state.loadingTopicInformation) {
            return (this._renderLoadingRightCol());
        }
        return (
          <div className='col l5 m12 s12'>
            <RcIf if={this.state.relatedTopics.length > 0}>
              <TopicBoxRelated relatedTopics={this.state.relatedTopics} />
            </RcIf>
            <OtherOptions otherOptions={this.state.otherOptions} />
            <Suggested topicSuggestions={this.state.topicSuggestions} />
          </div>
        );
    }

    isCreator = () => {
        if (this.state.userData && this.state.currentTopic && this.state.currentTopic.createdBy) {
            return (this.state.currentTopic.createdBy.username === this.state.userData.username);
        }
        return false;
    }

    _renderLoadingLeftCol = () => {
        return (
          <div className='col l7 s12 tops topCard'>
            <div className='leftCol'>
              <img src='/images/loaders/load-top.svg' className='leftCol' />
            </div>
          </div>
        );
    }
    goToMyTopic = () => {
        return history.push('/topic/' + Utilities.getHumanUrl(this.state.sameTopicByMe));
    }
    _renderOptions = () => {
        let options = this.state.currentTopic.options;
        if (this.state.enableEditing) {
            options = !this.isCreator() ? this.state.options : this.state.creatorOptions;
        }
        if (this.state.loadingOptions) {
            return this._renderLoadingLeftCol();
        }
        return (
          <div className='col l7 m12 s12 tops topCard'>
            <OptionsHeader
              isCreator={this.isCreator()}
              makeTop={this.makeTop}
            />
            <TopBox
              isGlobal={this.state.globalTopic}
              loading={this.state.loadingOptions}
              options={options}
              topic={this.state.topic && this.state.topic.replace(/-/g, ' ')}
              enableEditing={this.state.enableEditing}
              />
            <OptionsFooter
              isCreator={this.isCreator()}
              handleNewTopic={this.handleNewTopic}
              url={this.state.url}
            />
          </div>
        );
    }

    render () {
        let options = [];
        if (this.state.enableEditing) {
            options = this.state.options;
        } else {
            options = this.state.currentTopic.options;
        }
        let strOptions = options.map((option) => {
            return option.sentence;
        });
        const meta = {
            title: 'Top 5 ' + this.state.title || 'Top5.global',
            description: 'En el puesto numero 1: ' + strOptions[0] + '! Mirá los otros puestos...',
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: 'react,meta,document,html,tags'
                },
                property: {
                    'og:url': this.state.url,
                    'og:title': 'Top 5 ' + this.state.title || 'top5.global',
                    'og:description': 'En el puesto numero 1: ' + strOptions[0] + '! Mirá los otros puestos...',
                    'og:image': process.env.REACT_APP_PUBLIC_URL + '/images/top5-global.jpg',
                    'fb:app_id': process.env.REACT_APP_FB_APP_ID,
                    'twitter:site': '@top5globalnow',
                    'twitter:card': 'summary'
                }
            }
        };

        return (
          <div>
            <TopicHeader loadingOptions={this.state.loadingOptions} globalTopic={this.state.globalTopic} currentTopic={this.state.currentTopic} topicActivity={this.state.topicActivity} isTopicFaved={this.state.isTopicFaved} />
            <div className='container-gral total_container_mobile'>
              <DocumentMeta {...meta} />
              <div className='margin-top nopad' />
              <div className='tops'>
                <div className='row'>
                  {this._renderOptions()}
                  {this._renderTopicInformation()}
                </div>
              </div>
              <RcIf if={!this.state.autogenerateTitle && !this.state.enableEditing} >
                <Comments globalTopic={this.state.globalTopic} />
              </RcIf>
            </div>
          </div>
        );
    }
}

export default Topic;



// WEBPACK FOOTER //
// ./src/sections/Topic.js